<div class="gocam-container">
  <iframe src="/gocam_connections" class="gocam-iframe" #gocamiframe>
  </iframe>
</div>
